import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/App";

const PartnersStrip = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios.get(`${API}/partners`).then((r) => setPartners(r.data)).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  return (
    <div className="bg-[#FFC2E8] border-t-2 border-[#0A0A0A]" data-testid="partners-strip">
      <div className="container-main py-5">
        <div className="flex items-center gap-6 flex-wrap justify-center">
          <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#0A0A0A] flex-shrink-0">
            Supported by
          </span>
          <div className="flex items-center gap-8 flex-wrap justify-center">
            {partners.map((p) => {
              const img = (
                <img
                  src={p.logo_url}
                  alt={p.name}
                  className="h-8 max-w-[140px] object-contain hover:scale-105 transition-transform"
                  loading="lazy"
                />
              );
              return p.website ? (
                <a
                  key={p.partner_id}
                  href={p.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={p.name}
                  data-testid={`strip-partner-${p.partner_id}`}
                >
                  {img}
                </a>
              ) : (
                <div key={p.partner_id} aria-label={p.name} data-testid={`strip-partner-${p.partner_id}`}>
                  {img}
                </div>
              );
            })}
          </div>
          <a
            href="https://ko-fi.com/c/b4ab046cde"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-auto text-[10px] font-bold uppercase tracking-[0.2em] text-[#0A0A0A] hover:text-[#FF2D87] inline-flex items-center gap-1 transition-colors flex-shrink-0"
            data-testid="strip-become-partner"
          >
            Become a Partner <ArrowUpRight className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PartnersStrip;
